import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';
import enquiriesTools from "@/employee/enquiries/enquiriesTools";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'propertyDetails',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    AttachmentsComp: require('./customerAttachements.vue').default,
    PropertyApplicationsComp: require('./propertyApplications.vue').default,
    PropertyHistoryComp: require('./propertyHistory.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    InputWithViewDetails: require('@/common/inputWithViewDetails/inputWithViewDetails.vue').default,
    SewerConnectionComp: require('./propertyDetailsSewerConnection.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    CustomerCustomFields: require('@/employee/enquiries/customerCustomFields/customerCustomFields.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      typeMains: '',
      loading: true,
      menuVisible: true,
      selectedTab: 'general',
      scrollAmt: 200,
      CUSTKEY: '',
      PROPERTYID: '',
      lang: '',
      tabs: [],
      mainTypesList: [],
      mainType: '',
      assestmentList: [],
      assestment: 0,
      addressTypeList: [
        { index: 0, Text: this.$t('enquiriesCustomerDetails.codedAddress') },
        { index: 1, Text: this.$t('enquiriesCustomerDetails.uncodedAddress') }
      ],
      codedAddressUncoded: '',
      addressType: 0,
      PropertyRef: '',
      OwnersList: [],
      OwnersListDisplayMember: '',
      Owner: 0,
      Tenant: '',
      Tenant2: '',
      MinChargeWater: '',
      MinChargeSewer: '',
      WaterServiceCheck: false,
      SewerServiceCheck: false,
      ElectricityServiceCheck: false,
      Address1: '',
      Address2: '',
      Address3: '',
      Address4: '',
      Address5: '',
      Code: '',
      CareOf: '',
      HouseNo: '',
      FlatName: '',
      FlatNo: '',
      BuildingName: '',
      BuildingNameLabel: '',
      Township: '',
      Town: '',
      ShowBuildingName: false,
      OldKey: '',
      PlotRef: '',
      ConsumptionGroup: '',
      ConsumptionType: '',
      WaterTariff: '',
      SewerTariff: '',
      TemporarilyVacated: false,
      PropertyArea: '',
      PropertyValue: '',
      NoFlats: '',
      NoOccupants: '',
      NoTenants: '',
      NoSinks: '',
      NoRooms: '',
      flag1DataSource: [],
      flag2DataSource: [],
      flag3DataSource: [],
      flag4DataSource: [],
      flag5DataSource: [],
      flag1Label: '',
      flag2Label: '',
      flag3Label: '',
      flag4Label: '',
      flag5Label: '',
      flag1: '',
      flag2: '',
      flag3: '',
      flag4: '',
      flag5: '',
      distMains: '',
      sizeMains: '',
      minFlow: '',
      peakFlow: '',
      quality: '',
      volume: '',
      ref: '',
      assestDate: '',
      sewerLicNo: '',
      sewerLicStatus: '',
      zoneScheme: '',
      zone: '',
      nodeArea: '',
      comments: '',
      Applications: [],
      ApplicationsCols: [],
      CallHistory: [],
      CallHistoryCols: [],
      DetailChanges: [],
      DetailChangesCols: [],

      detailChangesTotalRow: 0,
      detailChangesPageingoptions: { pageSize: 10, total: 0, page: 1 },

      OwnersListDisplay: [],
      OwnersCols: [],
      OwnerSelected: '',
      ownersTotalRow: 0,
      ownersPageingoptions: { pageSize: 10, total: 0, page: 1 },
      tariffAllocation: [],
      connections: [],
      selectedConnId: 0,
      SewerConnections: [],
    }
  },
  computed: {
    isRtl: function () {
      return this.lang == 'ar' ? true : false;
    },
    selectedTabObj: function () {
      return this.tabs.filter(t => t.id == this.selectedTab)[0];
    },
    assestmentDisplay: {
      get: function() {
        let temp = this.assestmentList.filter(a => a.id == this.assestment);

        if (temp && temp.length > 0)
          return temp[0].text;
        else
          return '';
      },
      set: function () { }
    },
    addressTypeDisplay: {
      get: function() {
        let temp = this.addressTypeList.filter(a => a.index == this.addressType);

        if (temp && temp.length > 0)
          return temp[0].text;
        else
          return '';
      },
      set: function () { }
    },
  },
  watch: {
    selectedTab: function (val) {
      if (!val)
        return;

      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrl(val);
    },
  },
  created() {
    this.PROPERTYID = this.$route.params.PROPERTYID;
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.configDetailChangesColumns();
    this.configOwnersColumns();
    this.discountsColumns();
    this.tabs = [
      {
        id: "general",
        show: true,
        ...this.enqIcons.general,
      },
      {
        id: "references",
        label: this.$t("enquiriesPropertyDetails.references"),
        show: true,
        icon: this.enqIcons.details.icon,
      },
      {
        id: "otherDetails",
        label: this.$t("enquiriesPropertyDetails.otherDetails"),
        show: true,
        icon: this.enqIcons.info.icon,
      },
      {
        id: "tariffAllocations",
        label: this.$t("enquiriesPropertyDetails.tariffAllocations"),
        show: false,
        icon: this.enqIcons.pie.icon,
      },
      {
        id: "engineering",
        show: true,
        ...this.enqIcons.engineering,
      },
      {
        id: "owners",
        show: true,
        ...this.enqIcons.owners,
      },
      {
        id: "applications",
        show: true,
        ...this.enqIcons.applications,
      },
      {
        id: "propertyHistory",
        show: true,
        ...this.enqIcons.history,
      },
      {
        id: "comments",
        show: true,
        ...this.enqIcons.comments,
      },
      {
        id: "attachments",
        show: true,
        ...this.enqIcons.attachments,
      },
      {
        id: "detailchanges",
        show: true,
        ...this.enqIcons.detailChanges,
      },
      {
        id: "discounts",
        show: false,
        ...this.enqIcons.discounts,
      },
      {
        id: "dataSheet",
        show: true,
        icon: this.enqIcons.tableChart.icon,
        label: this.$t("enquiriesPropertyDetails.dataSheet"),
      },
    ];

    this.findDefaultTab();
  },
  mounted() {
    this.menuVisible = this.getFromLocal('_enquries_prop_det');
    this.getLookups();
  },
  methods: {
    getLookups() {
      axios.post('/Enquiries/GetPropertyDetailsLookups', { Value: this.getLoginName() })
        .then(response => {
          if (response.status == 200) {

            console.log(response.data);

            this.mainTypesList = response.data.mainTypeList;
            this.mainType = this.mainTypesList == null ? '' : this.mainTypesList.length == 0 ? '' : this.mainTypesList[0]['code'];

            this.assestmentList = response.data.assestment;
            this.assestment = this.assestmentList == null ? '' : this.assestmentList.length == 0 ? '' : this.assestmentList[0]['id'];

            this.getPropertyDetails();
            this.getPropertyDiscounts();
          }
        })
        .catch(e => this.getDataFailed(e));
    },
    getPropertyDetails() {
      var parameters = {
        propertyId: this.PROPERTYID,
        loginEmail: this.getLoginName()
      }

      axios.post('/Enquiries/GetPropertyDetails', parameters)
        .then(response => {
          if (response.status == 200) {
            //console.log('response.data', response.data);

            this.PropertyRef = response.data.property.propRef;
            this.OwnersList = response.data.property.ownersList;
            this.fillOwners();

            this.ownersTotalRow = this.OwnersList.length ?? 0;
            this.OwnersListDisplayMember = response.data.property.ownersListDisplayMember;
            this.Owner = response.data.property.ownerSelected;
            this.OwnerSelected = this.OwnersList[this.Owner];
            this.Tenant = response.data.property.tenant;
            this.Tenant2 = response.data.property.tenant2;
            this.MinChargeWater = response.data.property.minChargeWater;
            this.MinChargeSewer = response.data.property.minChargeSewer;
            this.WaterServiceCheck = response.data.property.waterServiceCheck;
            this.SewerServiceCheck = response.data.property.sewerServiceCheck;
            this.ElectricityServiceCheck = response.data.property.electricityServiceCheck;
            this.addressType = response.data.property.addressType;
            this.Address1 = response.data.property.address;
            this.Address2 = response.data.property.address2;
            this.Address3 = response.data.property.address3;
            this.Address4 = response.data.property.address4;
            this.Address5 = response.data.property.address5;
            this.Code = response.data.property.code;
            this.CareOf = response.data.property.careOf;
            this.HouseNo = response.data.property.houseNo;
            this.FlatName = response.data.property.flatName;
            this.FlatNo = response.data.property.flatNo;
            this.BuildingName = response.data.property.buildingName;
            this.BuildingNameLabel = response.data.property.buildingNameLabel;
            this.Township = response.data.property.township;
            this.Town = response.data.property.town;
            this.OldKey = response.data.property.oldKey;
            this.PlotRef = response.data.property.plotRef;
            this.ConsumptionGroup = response.data.property.consGroup;
            this.ConsumptionType = response.data.property.consType;
            this.WaterTariff = response.data.property.waterTariff;
            this.SewerTariff = response.data.property.sewerTariff;
            this.TemporarilyVacated = response.data.property.isVacated;
            this.PropertyArea = response.data.property.area;
            this.PropertyValue = response.data.property.value;
            this.NoFlats = response.data.property.flats;
            this.NoOccupants = response.data.property.occupants;
            this.NoTenants = response.data.property.tenancy;
            this.NoSinks = response.data.property.sinks;
            this.NoRooms = response.data.property.rooms;
            this.flag1DataSource = response.data.property.flag1DataSource;
            this.flag2DataSource = response.data.property.flag2DataSource;
            this.flag3DataSource = response.data.property.flag3DataSource;
            this.flag4DataSource = response.data.property.flag4DataSource;
            this.flag5DataSource = response.data.property.flag5DataSource;
            this.flag1Label = response.data.property.flag1Label;
            this.flag2Label = response.data.property.flag2Label;
            this.flag3Label = response.data.property.flag3Label;
            this.flag4Label = response.data.property.flag4Label;
            this.flag5Label = response.data.property.flag5Label;
            this.flag1 = response.data.property.flag1;
            this.flag2 = response.data.property.flag2;
            this.flag3 = response.data.property.flag3;
            this.flag4 = response.data.property.flag4;
            this.flag5 = response.data.property.flag5;
            this.distMains = response.data.property.distMains;
            this.sizeMains = response.data.property.sizeMains;
            this.minFlow = response.data.property.minFlow;
            this.peakFlow = response.data.property.peakFlow;
            this.typeMains = response.data.property.typeMains;
            this.quality = response.data.property.quality;
            this.volume = response.data.property.volume;
            this.ref = response.data.property.ref;
            this.assestDate = this.$options.filters.formatDateDDMMYYY(response.data.property.assest);
            this.assestment = response.data.property.assestment;
            this.sewerLicNo = response.data.property.sewerLicNo;
            this.sewerLicStatus = response.data.property.sewerLicStatus;
            this.zoneScheme = response.data.property.zoneScheme;
            this.zone = response.data.property.zone;
            this.nodeArea = response.data.property.nodeArea;
            this.comments = response.data.property.comments;

            this.tariffAllocation = response.data.property.tariffAllocation;
            this.SewerConnections = response.data.property.sewerConnections;

            this.SewerConnections.forEach(s => {
              s['uuid'] = uuidv4();
              s.connDateDisplay = this.$options.filters.formatDateDDMMYYY(s.connDate);
              s.statusDateDisplay = this.$options.filters.formatDateDDMMYYY(s.statusDate);
            });

            //this.tabs.filter(a => a.id == 'tariffAllocations')[0].show = true;

            if (this.tariffAllocation.length > 0 && response.data.property.connections.length > 0) {
              this.tabs.filter(a => a.id == 'tariffAllocations')[0].show = true;
              this.connections = response.data.property.connections;
              this.selectedConnId = response.data.property.connections[0];
            }

            this.fillDetailChanges();
          }
          else
            this.getDataFailed();
        })
        .catch(e => this.getDataFailed(e) )
    },

    configOwnersColumns() {
      this.OwnersCols.push({ dataField: 'custkey', caption: this.$t('common.Account') });
      this.OwnersCols.push({ dataField: 'name', caption: this.$t('common.Name') });
      this.OwnersCols.push({ dataField: 'share', caption: this.$t('activities.ownerShare') });
    },
    viewOwnerTenantDetails(type) {
      if (type == 'owner' && this.Owner > -1) 
        this.CUSTKEY = this.OwnersList[this.Owner].custkey;
      else if (type == 'tenant' && this.Tenant) 
        this.CUSTKEY = this.Tenant;
      else
        return;

      this.viewCustomerDetails({ data: { custkey: this.CUSTKEY } })
    },
    viewCustomerDetails(item) {
      this.openNewWindow(`/customerDetails/general/${item.data.custkey}`); 
    },
    ownersPageChange(pInfo) {
      this.ownersPageingoptions.page = pInfo.pageNumber;
      this.ownersPageingoptions.pageSize = pInfo.pageSize;
      this.fillOwners();
    },
    fillOwners() {
      let pNum = this.ownersPageingoptions.page - 1;
      let pSize = this.ownersPageingoptions.pageSize;

      let start = pNum * pSize;
      let end = (start + pSize);

      if (end > this.OwnersList.length - 1)
        end = this.OwnersList.length - 1;

      //console.log("start", start, "end", end)

      if (start >= end) {
        this.OwnersListDisplay.length = 0;
        this.OwnersListDisplay.push(this.OwnersList[start]);
      }
      else
        this.OwnersListDisplay = [...this.OwnersList.slice(start, end)];
    },

    configDetailChangesColumns() {
      this.DetailChangesCols.push({ dataField: 'field', caption: this.$t('enquiriesPropertyDetailChanges.property') });
      this.DetailChangesCols.push({ dataField: 'originalValue', caption: this.$t('enquiriesPropertyDetailChanges.originalValue') });
      this.DetailChangesCols.push({ dataField: 'newValue', caption: this.$t('enquiriesPropertyDetailChanges.newValue') });
      this.DetailChangesCols.push({ dataField: 'sourceId', caption: this.$t('enquiriesPropertyDetailChanges.applicationNo') });
      this.DetailChangesCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesPropertyDetailChanges.stampUser') });
      this.DetailChangesCols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesPropertyDetailChanges.stampDateTime'), dataType: 'date' });
    },
    detailChangesPageChange(pInfo) {
      this.detailsChangesPageingoptions.page = pInfo.pageNumber;
      this.detailsChangesPageingoptions.pageSize = pInfo.pageSize;
      this.fillDetailChanges();
    },
    fillDetailChanges() {
      var parameters = {
        propertyId: this.PROPERTYID,
        loginEmail: this.getLoginName(),
        Options: this.detailChangesPageingoptions
      }

      axios.post('/Enquiries/getPropertyDetailsChanges', parameters)
        .then(response => {
          if (response.status == 200) {
            this.DetailChanges = response.data.items;

            this.detailChangesTotalRow = response.data.itemsCount;
            this.loading = false;
          }
          else
            this.getDataFailed();
        })
        .catch(e => { this.getDataFailed(e) })
    },

    discountsColumns() {
      //this.DetailChangesCols.push({ dataField: 'transactionType', caption: this.$t('enquiriesPropertyDetailChanges.discountType') });
      //this.DetailChangesCols.push({ dataField: 'description', caption: this.$t('ApplicationsGrid.description') });
      //this.DetailChangesCols.push({ dataField: 'rate', caption: `${this.$t('activities.rate')} (%)` });
      //this.DetailChangesCols.push({ dataField: 'comments', caption: this.$t('assets.comments') });
      //this.DetailChangesCols.push({ dataField: 'sourceId', caption: this.$t('enquiriesPropertyDetailChanges.affectedCharges') });

      //this.DetailChangesCols.push({ dataField: 'field', caption: this.$t('enquiriesPropertyDetailChanges.discountType') });
      //this.DetailChangesCols.push({ dataField: 'originalValue', caption: this.$t('ApplicationsGrid.description') });
      //this.DetailChangesCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesPropertyDetailChanges.tarrifBand') });

      //DiscTrnsCode = i.DiscTrnsCode,
      //  DiscTrnsSCode = i.DiscTrnsSCode,
      //  Rate = i.Rate,
      //  Description =
      //  TransactionType.GetDisplayString(
      //    i.TransactionType.TransCode, i.TransactionType.TransSubCode, i.TransactionType.Title, i.TransactionType.Subtitle),

      //  Comments = i.Comments,
      //  Band = i.Band,
      //  IsFirst = true,
    },
    getPropertyDiscounts() {
      var parameters = {
        propertyId: this.PROPERTYID,
        loginEmail: this.getLoginName(),
        Options: this.detailChangesPageingoptions
      }

      axios.post('/Enquiries/GetPropertyDiscounts', parameters)
        .then(response => {
          if (response.status == 200) {
            console.log('response.data', response.data);

          }
        })
        .catch(e => {  return false; })
    },
    showOnMap() {
      const url1 = 'https://www.google.com/maps/search/';
      let url2 = this.replaceSpaceWithPlus(this.Address1 + ',' + this.Address2 + ',' + this.Address3 + ',' + this.Address4);

      if (url2)
        window.open(url1 + url2);
    },
    replaceSpaceWithPlus(str) {
      return str.replaceAll(' ', '+');
    },
  },
}

